import { CachedMasterDataService } from '../../api/cached-master-data-service';
import { MetricGroupId } from '../../graphql/generated/graphql-sdk';
import { MetricStore } from '../metric-store';
import {
  getPbsByDimensionServiceForCohortBackendMetrics,
  getPbsByDimensionServiceForEmployeeCohortBackendMetrics,
  getPbsByDimensionServiceForRegularBackendMetrics,
} from './getPbsByDimensionServiceForBackendMetrics';
import {
  getPbsOverTimeServiceForCohortBackendMetric,
  getPbsOverTimeServiceForEmployeeCohortBackendMetric,
  getPbsOverTimeServiceForRegularBackendMetric,
} from './getPbsOverTimeServiceForBackendMetrics';
import {
  getPbsSegmentationServiceForCohortBackendMetrics,
  getPbsSegmentationServiceForEmployeeCohortBackendMetrics,
  getPbsSegmentationServiceForRegularBackendMetrics,
} from './getPbsSegmentationServiceForBackendMetrics';

export const getMetricOverTimeService = (
  metricGroupId: MetricGroupId,
  metricStore: MetricStore,
  cachedMasterDataService: CachedMasterDataService
) => {
  return metricStore.isMetricGroupRegular(metricGroupId)
    ? getPbsOverTimeServiceForRegularBackendMetric(
        metricGroupId,
        cachedMasterDataService
      )
    : metricStore.isMetricGroupCohort(metricGroupId)
      ? getPbsOverTimeServiceForCohortBackendMetric(
          metricGroupId,
          cachedMasterDataService
        )
      : getPbsOverTimeServiceForEmployeeCohortBackendMetric(
          metricGroupId,
          cachedMasterDataService
        );
};

export const getMetricByDimensionService = (
  metricGroupId: MetricGroupId,
  metricStore: MetricStore,
  cachedMasterDataService: CachedMasterDataService
) => {
  return metricStore.isMetricGroupRegular(metricGroupId)
    ? getPbsByDimensionServiceForRegularBackendMetrics(
        metricGroupId,
        cachedMasterDataService
      )
    : metricStore.isMetricGroupCohort(metricGroupId)
      ? getPbsByDimensionServiceForCohortBackendMetrics(
          metricGroupId,
          cachedMasterDataService
        )
      : getPbsByDimensionServiceForEmployeeCohortBackendMetrics(
          metricGroupId,
          cachedMasterDataService
        );
};

export const getMetricSegmentationService = (
  metricGroupId: MetricGroupId,
  metricStore: MetricStore,
  cachedMasterDataService: CachedMasterDataService
) => {
  return metricStore.isMetricGroupRegular(metricGroupId)
    ? getPbsSegmentationServiceForRegularBackendMetrics(
        metricGroupId,
        cachedMasterDataService
      )
    : metricStore.isMetricGroupCohort(metricGroupId)
      ? getPbsSegmentationServiceForCohortBackendMetrics(
          metricGroupId,
          cachedMasterDataService
        )
      : getPbsSegmentationServiceForEmployeeCohortBackendMetrics(
          metricGroupId,
          cachedMasterDataService
        );
};
